import styled from '@emotion/styled';
import { Flex } from 'antd';
import { type FC, useEffect, useState } from 'react';
import { FormCheck } from '../../FormComponents';

interface Props {
  id: string;
  children: React.ReactNode;
  value?: boolean;
  onChange?: (newValue: boolean) => void;
}

export const FormCheckText: FC<Props> = ({ id, value = false, onChange, children }) => {
  const [cacheValue, setCacheValue] = useState(value);

  useEffect(() => {
    setCacheValue(value);
  }, [value]);

  const handleChange = (newValue: boolean) => {
    if (newValue !== cacheValue) {
      setCacheValue(newValue);
      onChange?.(newValue);
    }
  };

  return (
    <Flex>
      <FormCheck id={id} value={cacheValue} type="checkbox" onChange={handleChange} />
      <Text checked={cacheValue}>{children}</Text>
    </Flex>
  );
};

const Text = styled.div<{ checked: boolean }>`
  margin-left: 10px;
`;
